module.exports = __webpack_public_path__ + "static/media/close-nav-icon.93ce576b.svg";